import {
  IconUsers,
  IconAffiliate,
  IconBriefcase,
  IconBuildingWarehouse,
  IconHome2,
  IconFileText,
  IconDashboard,
  IconLogout,
  IconFileDescription,
  IconSettings,
  IconUserCircle,
  IconFolderSearch,
  IconDeviceDesktopDown,
  IconMail
} from '@tabler/icons-react';

export const iconMap = {
  IconUsers,
  IconAffiliate,
  IconBriefcase,
  IconBuildingWarehouse,
  IconHome2,
  IconFileText,
  IconDashboard,
  IconLogout,
  IconFileDescription,
  IconSettings,
  IconUserCircle,
  IconFolderSearch,
  IconDeviceDesktopDown,
  IconMail
};
